var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { resetFocus, selectFocusableChildren } from '../utils/dom';
import { useEventListener, } from './useEventListener';
/**
 * Hook that traps focus via `tab` key within an element.
 * When enabled, the hook will focus the first child of the parent element.
 * And when disabled, it will return focus to the previously focused element.
 */
export function useFocusTrap(ref, optionsProps) {
    if (optionsProps === void 0) { optionsProps = {}; }
    var defaultOptions = {
        isDisabled: false,
        isRestoreFocus: true,
    };
    var options = __assign(__assign({}, defaultOptions), optionsProps);
    var isDisabled = options.isDisabled, isRestoreFocus = options.isRestoreFocus;
    useEffect(function () {
        if (isDisabled) {
            return undefined;
        }
        var prevActiveElement = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        setTimeout(function () {
            var parent = ref.current;
            if (!parent || isDisabled) {
                return;
            }
            var focusableChildren = selectFocusableChildren(parent);
            var firstFocusable = focusableChildren.item(0);
            if (!firstFocusable) {
                resetFocus();
            }
            firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus({ preventScroll: true });
        }, 0);
        return function () {
            if (isRestoreFocus) {
                prevActiveElement === null || prevActiveElement === void 0 ? void 0 : prevActiveElement.focus({ preventScroll: true });
            }
        };
    }, [isDisabled, isRestoreFocus, ref]);
    useEventListener({
        ref: ref,
        target: 'keydown',
        listener: function (event) {
            var element = ref.current;
            if (event.key !== 'Tab' || !element || isDisabled) {
                return;
            }
            var focusableChildren = selectFocusableChildren(element);
            var firstFocusable = focusableChildren.item(0);
            var lastFocusable = focusableChildren.item(focusableChildren.length - 1);
            switch (document.activeElement) {
                case lastFocusable: {
                    event.preventDefault();
                    firstFocusable.focus();
                    break;
                }
                case firstFocusable: {
                    if (event.shiftKey) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                    break;
                }
                default:
            }
        },
    });
}
//# sourceMappingURL=useFocusTrap.js.map